module.exports = __webpack_public_path__ + "img/FI21817028.a354e2e1.svg";